<template>
  <div>
    <div class="text-caption text--secondary mt-6 mb-3">
      Grafik progres bulanan · Tahun {{ selectedYear }}
    </div>

    <v-alert
      v-if="simpelbangGrafikError"
      type="warning"
      dense
      text
      class="mb-4">
      {{ simpelbangGrafikError }}
    </v-alert>

    <v-row class="chart-grid">
      <v-col
        cols="12"
        md="12">
        <v-card
          outlined
          class="simpelbang-chart-card h-100 rounded-xl">
          <v-card-text>
            <div class="text-subtitle-2 font-weight-bold mb-3">
              Grafik Fisik
            </div>
            <div
              v-if="simpelbangGrafikLoading"
              class="simpelbang-chart-loading">
              <v-progress-circular
                indeterminate
                color="primary"
                size="38" />
              <div class="text-caption text--secondary mt-2">Memuat grafik fisik…</div>
            </div>
            <client-only v-else-if="simpelbangHasGrafikData">
              <apexchart
                type="line"
                :height="320"
                :options="simpelbangFisikChartOptions"
                :series="simpelbangFisikSeries" />
            </client-only>
            <div
              v-else
              class="simpelbang-chart-empty">
              <v-icon
                color="grey lighten-1"
                class="mb-1">
                mdi-chart-line
              </v-icon>
              <div class="text-caption text--secondary">Belum ada data grafik fisik</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col
        cols="12"
        md="12">
        <v-card
          outlined
          class="simpelbang-chart-card h-100 rounded-xl">
          <v-card-text>
            <div class="text-subtitle-2 font-weight-bold mb-3">
              Grafik Keuangan
            </div>
            <div
              v-if="simpelbangGrafikLoading"
              class="simpelbang-chart-loading">
              <v-progress-circular
                indeterminate
                color="primary"
                size="38" />
              <div class="text-caption text--secondary mt-2">Memuat grafik keuangan…</div>
            </div>
            <client-only v-else-if="simpelbangHasGrafikData">
              <apexchart
                type="line"
                :height="320"
                :options="simpelbangKeuanganChartOptions"
                :series="simpelbangKeuanganSeries" />
            </client-only>
            <div
              v-else
              class="simpelbang-chart-empty">
              <v-icon
                color="grey lighten-1"
                class="mb-1">
                mdi-chart-areaspline
              </v-icon>
              <div class="text-caption text--secondary">Belum ada data grafik keuangan</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'SimpelbangCharts',
  props: {
    selectedYear: {
      type: Number,
      required: true
    },
    simpelbangGrafikError: {
      type: String,
      default: ''
    },
    simpelbangGrafikLoading: {
      type: Boolean,
      default: false
    },
    simpelbangHasGrafikData: {
      type: Boolean,
      default: false
    },
    simpelbangFisikChartOptions: {
      type: Object,
      required: true
    },
    simpelbangFisikSeries: {
      type: Array,
      default: () => []
    },
    simpelbangKeuanganChartOptions: {
      type: Object,
      required: true
    },
    simpelbangKeuanganSeries: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
.simpelbang-chart-card {
  border-radius: 24px;
  border: 1px solid rgba(21, 73, 135, 0.12) !important;
  background: #ffffff;
}

.simpelbang-chart-loading,
.simpelbang-chart-empty {
  min-height: 260px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

@media (max-width: 1080px) {
  .chart-grid {
    flex-direction: column;
  }
}
</style>
